
import React from 'react';
import { View, Image, Text, StyleSheet } from 'react-native';

import { addFontFamilylato, getImagePath } from '../../../utils/services/CommonUtils';

import { aayuCardBenifitsList } from '../../constants/acs/prePurcaseAayuData';

import AppTheme from "../../../AppTheme";
import TextStyle from '../../../TextStyle';

const AayuCardBenifits = () => {
    return (<View>
        <Text style={styles.benefitsLabel}>Benefits of Aayu Card</Text>
        <View style={styles.benefitsContainer}>
            {
                aayuCardBenifitsList.map((benefits, idx) => (
                    <View style={[styles.benefits]}
                        key={'aayu_benefit_' + idx}>
                        <Image style={{ height: 90, aspectRatio: 1 }}
                            source={{ uri: getImagePath(benefits.imageUrl) }} />
                        <Text style={[TextStyle.text14, {
                            width: 124, flexWrap: 'wrap', textAlign: 'center'
                        }]}>{benefits.title}</Text>
                    </View>
                ))
            }
        </View>
    </View>)
}

export default AayuCardBenifits;

const styles = StyleSheet.create(addFontFamilylato({
    benefitsView: {

    },
    benefitsLabel: {
        fontSize: 20,
        color: AppTheme.color.black,
        fontWeight: '500',
        alignItems: 'center',
        textAlign: 'center'
    },
    benefitsContainer: {
        marginVertical: 8,
        flexDirection: 'row',
        flexWrap: 'wrap',
        justfyContent: 'space-between',
        alignContent: "space-between"
        // alignItems: "center",

    },
    benefits: {
        width: AppTheme.appWidth * 0.5 - 42,
        alignItems: 'center',
        alignContent: "center",
        padingHorizontal: AppTheme.appWidth * 0.25 - 80,
        marginVertical: 18,
        textAlign: 'center',
        justfyContent: 'center'
    }
}))